import { ConversationEntity } from 'widget_main/store/types';

export const getFilteredConversations = (
  conversationsList: ConversationEntity[],
  noHistory: boolean,
  unreadConversationIds: string[] = [],
) => {
  // Filter out conversations that have been merged into other conversations
  const filteredConversations = conversationsList.filter(
    (conversation) => !conversation.movedToConversationId,
  );

  if (noHistory) {
    return filteredConversations.filter(
      (conversation) =>
        !conversation.ended ||
        unreadConversationIds.some((c) => c === conversation.conversationId),
    );
  }
  return filteredConversations;
};

const hasUnread = (
  conversation: ConversationEntity,
  unreadCounts: Readonly<Record<string, number>>,
) => (unreadCounts[conversation.conversationId] ?? 0) > 0;

const isOpenConversation = (conversation: ConversationEntity) =>
  !conversation.ended;

const lastMessageAtSortKey = (conversation: ConversationEntity) =>
  conversation.lastMessageAt
    ? new Date(conversation.lastMessageAt).getTime()
    : 0;

export const sortConversationsForHistory = (
  conversationsList: ConversationEntity[],
  unreadCounts: Readonly<Record<string, number>>,
) =>
  conversationsList.sort((a, b) => {
    const aUnread = hasUnread(a, unreadCounts);
    const bUnread = hasUnread(b, unreadCounts);
    if (aUnread !== bUnread) {
      return aUnread ? -1 : 1;
    }

    const aOpen = isOpenConversation(a);
    const bOpen = isOpenConversation(b);
    if (aOpen !== bOpen) {
      return aOpen ? -1 : 1;
    }

    const aLastMessageAt = lastMessageAtSortKey(a);
    const bLastMessageAt = lastMessageAtSortKey(b);
    if (aLastMessageAt !== bLastMessageAt) {
      return bLastMessageAt - aLastMessageAt;
    }

    return a.conversationId.localeCompare(b.conversationId);
  });
